import Corrections from "./Corrections"

export default Corrections
